// Which PERSON's profile some surface has asked the shell to show (ART-264).
//
// The `messagePanel.ts` shape, for the same reason: a person's face or name appears all over the product (a chat
// author line, a chat's member list, the contacts list, a friend band's crew), and threading an opener prop through
// each of them would put the shell in the middle of surfaces that otherwise know nothing about it. `ProfileHost`
// subscribes and draws the ONE person dialog — `CrewProfileModal` on desktop, `ProfileSheet` on a phone — so every
// door opens the same thing, over whatever is on screen, and closing it returns the reader to where they were.
import { create } from "zustand";
import { registerStoreReset } from "./stores.js";

interface ProfilePanelState {
  /** The person whose profile is open, or null for none. */
  personId: string | null;
  open: (personId: string) => void;
  close: () => void;
}

export const useProfilePanel = create<ProfilePanelState>((set) => ({
  personId: null,
  open: (personId) => set({ personId }),
  close: () => set({ personId: null }),
}));

// Scorch on org/band switch + logout — a profile left open over the previous tenant must not survive into the next.
registerStoreReset(() => useProfilePanel.getState().close());

/** Open a person's profile over the current screen. */
export function openPersonProfile(personId: string): void {
  useProfilePanel.getState().open(personId);
}
